/* eslint-disable @typescript-eslint/no-explicit-any */

import { TFunction } from "i18next";

import { SvgIcon } from "@/components/Icon/SvgIcon";
import { TableColumn } from "@/components/Table/Table";

import { ReactComponent as copy } from "@assets/icons/create-list/copy.svg";
import { ReactComponent as pencil } from "@assets/icons/create-list/pencil.svg";
import { ReactComponent as trash } from "@assets/icons/create-list/trash.svg";

interface LiProfileSourceColumnsParams {
	t: TFunction<"translation">;
	handleSelect?: (row: any) => void;
	handleDuplicate?: (row: any) => void;
	handleDeleteModal?: (row: any) => void;
}

/**
 * Columns for LinkedIn-profile sources in the "Added sources" table: name, type, and the
 * duplicate / edit / delete actions.
 *
 * Extracted from `addedSearchTableConfigs.tsx` while adding the XLS Statistics action
 * (PREC-3870) — that file is over the 500-line ceiling, so anything added to it has to pay for
 * itself. It follows the same shape as its neighbours `getCsvEnrichmentSourceColumns` and
 * `getParallelAiSourceColumns`.
 */
export const getLiProfileSourceColumns = ({
	t,
	handleSelect,
	handleDuplicate,
	handleDeleteModal,
}: LiProfileSourceColumnsParams): TableColumn[] => [
	{
		title: "name",
		uid: "name",
		allowExclude: false,
		hideable: false,
		moveable: false,
		show: true,
		render: (row: any) => <div className="flex items-center">{row.name}</div>,
	},
	{
		title: "type",
		uid: "type",
		allowExclude: false,
		hideable: false,
		moveable: false,
		show: true,
		render: (row: any) => <div className="flex items-center">{t?.(`list.${row.type}`)}</div>,
	},
	{
		title: "",
		uid: "action",
		allowExclude: false,
		hideable: false,
		moveable: false,
		show: true,
		render: (row: any) => (
			<div className="flex items-center grow justify-end">
				<SvgIcon
					className="w-[24px] h-[24px] cursor-pointer text-gray-700 ml-1"
					svgIcon={copy}
					onClick={() => {
						handleDuplicate?.(row);
					}}
				/>
				<SvgIcon
					className="w-[24px] h-[24px] cursor-pointer text-gray-700 ml-1"
					svgIcon={pencil}
					onClick={() => {
						handleSelect?.(row);
					}}
				/>
				<SvgIcon
					className="w-[24px] h-[24px] cursor-pointer text-gray-700 ml-1"
					svgIcon={trash}
					onClick={() => {
						handleDeleteModal?.(row);
					}}
				/>
			</div>
		),
	},
];
